"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const pixi_1 = require("./pixi");
/*
 * MODELS
 */
class Walker extends pixi_js_1.Point {
    constructor() {
        super(...arguments);
        this.weight = 1.5;
    }
    step(targetX, targetY) {
        const targetDist = Math.sqrt(targetX ** 2 + targetY ** 2);
        const targetAngleCos = Math.acos(targetX / targetDist);
        const targetAngleSin = Math.asin(targetY / targetDist);
        const speed = Math.max(0, 1 - targetDist);
        let deltaX, deltaY;
        if (targetDist > 0.01 && Math.random() > targetDist * 2 && Math.random() < this.weight) {
            deltaX = Math.cos(targetAngleCos) * speed;
            deltaY = Math.sin(targetAngleSin) * speed;
        }
        else {
            deltaX = Math.sign(Math.random() - 0.5);
            deltaY = Math.sign(Math.random() - 0.5);
        }
        this.x += deltaX;
        this.y += deltaY;
    }
}
/*
 * CONTROLLER
 */
const draw = new pixi_js_1.Graphics();
pixi_1.pixiApp.stage.addChild(draw);
draw.lineStyle(2, 0x000000, 1);
const walker = new Walker(pixi_1.pixiApp.renderer.width / 2, pixi_1.pixiApp.renderer.height / 2);
draw.moveTo(walker.x, walker.y);
pixi_1.pixiApp.ticker.speed = 2;
pixi_1.pixiApp.ticker.add(() => {
    let mouseX = pixi_1.pixiApp.renderer.plugins.interaction.mouse.global.x;
    let mouseY = pixi_1.pixiApp.renderer.plugins.interaction.mouse.global.y;
    let relMouseX, relMouseY;
    if (mouseX < 0 || mouseY < 0 || mouseX > pixi_1.pixiApp.renderer.width || mouseY > pixi_1.pixiApp.renderer.height) {
        relMouseX = 0;
        relMouseY = 0;
    }
    else {
        relMouseX = (mouseX - walker.x) / Math.min(pixi_1.pixiApp.renderer.width, pixi_1.pixiApp.renderer.height);
        relMouseY = (mouseY - walker.y) / Math.min(pixi_1.pixiApp.renderer.width, pixi_1.pixiApp.renderer.height);
    }
    draw.moveTo(walker.x, walker.y);
    walker.step(relMouseX, relMouseY);
    draw.lineTo(walker.x, walker.y);
});
